import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import ConfirmDialog from 'Shared/ConfirmDialog';
import EnhancedTable from 'Shared/EnhancedTable';
import GlobalLoader from 'Shared/GlobalLoader/GlobalLoader';
import Password from '../Password/Password';
import { defaultMessage, deleteUser, getUsers } from '../UsersService';
import { columns } from './constants';

const UserList = ({ selectUser, update }) => {
  const [userData, setUserData] = useState();
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openPassword, setOpenPassword] = useState(false);
  const [localUpdate, setLocalUpdate] = useState(0);
  const handleClose = () => {
    setOpen(false);
  };
  const handleClosePassword = () => {
    setOpenPassword(false);
  };
  const firePopup = (u, setOpenFun) => () => {
    setUser(u);
    setOpenFun(true);
  };
  const getUserList = useCallback(async (sortParams) => {
    try {
      setLoading(true);
      const data = await getUsers(sortParams);
      setUserData(data);
    } catch (e) {
      const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
      toast.error(statusLabel);
    } finally {
      setLoading(false);
    }
  }, [setUserData, setLoading]);
  const users = (userData?.content || []).map((u) => ({
    ...u,
    action: {
      edit: selectUser(u),
      deleteUser: firePopup(u, setOpen),
      password: firePopup(u, setOpenPassword),
    },
  }));
  const handleDelete = async () => {
    try {
      setLoading(true);
      await deleteUser(user.id);
      setOpen(false);
      setLocalUpdate((u) => u + 1);
      toast.success('Utilisateur a été supprimé avec succès');
    } catch (e) {
      const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
      toast.error(statusLabel);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && <GlobalLoader size="100vh" />}
      {open && (
        <ConfirmDialog
          title="Suppression"
          content={`Voulez vous vraiment supprimer l'utilisateur ${user.username} ?`}
          handleClose={handleClose}
          handleClick={handleDelete}
        />
      )}
      {openPassword && <Password handleClose={handleClosePassword} user={user} />}
      <EnhancedTable
        getData={getUserList}
        rows={users}
        headCells={columns}
        count={userData?.totalElements}
        rowsPerPageOptions={[10, 15, 20]}
        update={`${update}:${localUpdate}`}
      />
    </>
  );
};

export default UserList;
